import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import isoWeek from "dayjs/plugin/isoWeek";
import updateLocale from 'dayjs/plugin/updateLocale';
import { BrowserRouter } from 'react-router-dom';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Importar estilos en el orden correcto
import '@mantine/core/styles.css';
import './index.css';

import App from './App.tsx';
import { theme } from './theme/theme';
import { ProveedorCargando } from './globales/contextos/cargandoContext.tsx';

// Crear cache de Emotion con prepend: true para que los estilos de Emotion tengan prioridad
const cache = createCache({ 
  key: 'ck', 
  prepend: true,
  speedy: false // Desactiva el modo speedy para desarrollo
});

// Configurar dayjs
dayjs.extend(updateLocale);
dayjs.updateLocale('es', {
  months: [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ]
});
dayjs.locale('es');
dayjs.extend(isoWeek);



ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CacheProvider value={cache}>
    {/* Envuelve tu componente App con MantineProvider */}
    <BrowserRouter>
      <MantineProvider theme={theme}>
        <ProveedorCargando>
          <App />
        </ProveedorCargando>
      </MantineProvider>
    </BrowserRouter>
    </CacheProvider>
  </React.StrictMode>
);